import ImageCompare from 'image-compare-viewer';

export default () => ({
  isLoading: false,
  data: {},
  content: '',
  isActive: false,
  categories: {
    environment: 'Životní prostředí',
    educulture: 'Školství, kultura a volný čas',
    construction: 'Infrastruktura a stavby',
    future: 'Vize',
  },
  fetchMarkerData(e) {
    if (this.$store.router.id) {
      this.isLoading = true;
      this.isActive = true;
      fetch(`/projects/${this.$store.router.id}`)
        .then((resp) => resp.json())
        .then((data) => {
          this.data = data;

          fetch('/projects/render-content', {
            method: 'post',
            headers: {
              'Content-Type': 'application/json',
              // 'Content-Type': 'application/x-www-form-urlencoded',
            },
            body: JSON.stringify(this.data.content),
          })
            .then((resp) => resp.text())
            .then((content) => {
              this.content = content;

              this.$nextTick(() => {
                this.initContent();
              });
            });
        });
    } else {
      this.isActive = false;
    }
  },
  getCategoryName(cat) {
    return this.categories[cat];
  },
  closeInfoSheet(doNavigation = true) {
    if (doNavigation) {
      this.$dispatch('navigate', '/');
    }
    this.isActive = false;
    this.data = {};
    this.content = '';
  },
  openShareDialog() {
    this.$dispatch('open-share-dialog');
  },
  getMainImageUrl(path) {
    const params = [
      `${this.$store.config.baseCockpitUrl}api/cockpit/image?token=${this.$store.config.publicApiKey}`,
      `src=${path}`,
      'w=1200',
      'h=500',
      'q=70',
      'm=fitToWidth',
      're=1',
    ];
    return `url(${params.join('&')})`;
  },
  formatPrice(number = 0) {
    return new Intl.NumberFormat('cs-CZ', {
      style: 'currency',
      currency: 'CZK',
      maximumSignificantDigits: 15,
    }).format(number);
  },
  initContent() {
    this.isLoading = false;
    setTimeout(() => {
      const viewers = document.querySelectorAll('.Content-beforeAfterImage');

      viewers.forEach((element) => {
        new ImageCompare(element, {
          smoothing: false,
          showLabels: true,
          labelOptions: {
            before: 'Před',
            after: 'Po',
            onHover: false,
          },
          addCircle: true,
          addCircleBlur: false,
        }).mount();
      });
    });
  },
});
